customElements.define(
  'section-render',
  class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
     this.params = this.params;

      if(this.dataset.onInit == "true") {
        this.load();
      }
    }

    get responseTarget() {
      return document.querySelector(this.dataset.responseTarget);
    }

    get params() {
      return this.dataset.params;
    }

    get context() {
      return this.dataset.contextUrl;
    }

    set params(str) {
      if (!this.searchParams) {
        this.searchParams = new URLSearchParams(str);
        this.dataset.params = this.searchParams.toString();
      } else {
        let split = str.split(",");
        this.searchParams.set(split[0],split[1]);
        this.dataset.params = this.searchParams.toString();
      }
    }

    get url() {
      let context = this.context
        ? this.context.indexOf('/') == 0 
          ? this.context.substring(1)
          : this.context
        : null;
      
      let params = this.params
        ? "?" + this.params
        : "";

      return context 
      ? window.Shopify.routes.root + context + params
      : window.Shopify.routes.root + params
    }

    load() {
      var isHTML = this.searchParams.has('section_id');
      fetch(this.url)
      .then(res => {
        if (isHTML) {
          return res.text()
        }
        return res.json();
      })
      .then(data => {
        if(isHTML) {
          this._render(this.responseTarget, data);
        }
        if (!isHTML) {
          data.forEach( content => {
            this._render(this.responseTarget, content);          
          });
        }
        this._customEvent('section-render:loaded')
      })
      .catch(err => {
        console.error('Section-render', err)
        this._customEvent('section-render:error',err);
      });
  
      // Multiple sections or nah
    }

    _render(target, data) {
      var html = new DOMParser()
        .parseFromString(data, 'text/html')
        .querySelector('.shopify-section')
        .innerHTML;

      target.innerHTML = html;
      this._customEvent('section-render:render')
    }

    _customEvent(type,message) {
      this.dispatchEvent(
        new CustomEvent(
          type,
          {
            bubbles: true,
            detail: message 
              ? { message: message }
              : {}
          }
        )
      );
    }
  }
)

customElements.define(
  'recommended-product',
  class extends HTMLElement {
    constructor() {
      super();
      
    }

    connectedCallback() {
      this._handleSelectEvent();
      this._handleSubmit();
    }

    get form() {
      let form = this.querySelector('form');
      let select = this.querySelector('[data-recommended-product-select]');
      let btn = this.querySelector('[data-recommended-product-submit]');
      
      return {
        node: form,
        select: select,
        submitBtn: btn
      }
    }

    get cartDrawer() {
      return document.querySelector('cart-drawer-items');
    }

    _handleSelectEvent() {
      if (!this.form.select) return;

      this.form.select.addEventListener('change', (event) => {
        if (!event.target.value || event.target.value == "") {
          this.form.submitBtn.setAttribute('disabled', '');
        } else {
          this.form.submitBtn.removeAttribute('disabled');
        }
      })
    }

    _handleSubmit() {
      if (!this.form.node) return;

      this.form.node.addEventListener('submit', (event) => {
        event.preventDefault();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(this.form.node)
        })
        .then(res => res.json())
        .then(data => {
          this.remove();
          this._customEvent('recommended-product:added');
          this.cartDrawer.reloadContent();
          
        })
        .catch(err => console.error('ERROR: ',err));
      });
    }
    
    _customEvent(type,message) {
      this.dispatchEvent(
        new CustomEvent(
          type,
          {
            bubbles: true,
            detail: message 
              ? { message: message }
              : {}
          }
        )
      );
    }
  }
)